module.exports = __webpack_public_path__ + "static/media/feature-login.cbe430b6.png";